import script from "./additionalservices.vue?vue&type=script&setup=true&lang=js"
export * from "./additionalservices.vue?vue&type=script&setup=true&lang=js"

import "./additionalservices.vue?vue&type=style&index=0&id=b319726c&lang=scss"
import "./additionalservices.vue?vue&type=style&index=1&id=b319726c&lang=scss&scoped=scoped"

import exportComponent from "D:\\工作项目\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b319726c"]])

export default __exports__